

import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/card";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";

export default function CheckoutCardView({
  onChange,
  card,
  submit,
  goBack,
  isDisabled,
  error,
  isLoading,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          {error && <div className="flex w-full flex-col">
            <h2 className="text-2xl text-center font-bold">Houve um problema ao tentar realizar seu pagamento</h2>
            <h3 className="text-lg text-center">Clique no botão para tentar novamente</h3>
          </div>}
          {!error && <div>
            <h2 className="mt-6 text-black text-xl">Cartão de crédito</h2>
            <h3 className="text-black text-sm">Novo cartão</h3>
            <h4 className="text-black text-sm">Informe seus dados nos campos abaixo</h4>
            <div className="flex flex-col justify-center items-center">
              <InputMask
                value={card?.cardNumber as string}
                name="cardNumber"
                required
                onChange={onChange}
                type="text"
                mask="____ ____ ____ ______"
                replacement={{ _: /\d/ }}
                placeholder="Número do cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input
                value={card?.cardName as string}
                required
                onChange={onChange}
                type="text"
                name="cardName"
                placeholder="Nome no cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <InputMask
                value={card?.cardExpiration as string}
                name="cardExpiration"
                required
                onChange={onChange}
                type="text"
                mask="__/____"
                replacement={{ _: /\d/ }}
                placeholder="Vencimento"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <InputMask
                value={card?.cardDocument as string}
                name="cardDocument"
                required
                onChange={onChange}
                type="text"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                placeholder="CPF"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
            </div>
          </div>}
          <Button
            title={error ? "Tentar novamente" : "Finalizar"}
            type="submit"
            onClick={submit}
            isDisabled={isDisabled}
          />
        </article>
      </main>
      {isLoading && <Loading />}
    </div>
  );
}